import React, { FC } from 'react';
import './index.scss';

const StickyTopWrapper: FC<object> = () => {
  return (
    <div className="header">
      <div id="sticky-top-wrapper" className="sticky-top-wrapper"></div>
    </div>
  );
};

export default StickyTopWrapper;
